import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { AccountEditRequestBody, AccountEditResponse } from "./types";

export class AccountEditAPI extends BaseAPI<
  AccountEditRequestBody,
  AccountEditResponse
> {
  protected route = ApiRoutes.account.edit;
  protected method = RequestMethod.POST;
  protected params = ["accountId"];
}
